export type OptionsMapperType = Record<string, string>;

export function generateAutocompleteOptionsMapper<
  T extends Record<string, unknown>,
>(items: Array<T>, valueKey: keyof T, labelKey: keyof T): OptionsMapperType {
  return items.reduce(
    (optionsMapper: OptionsMapperType, current: T): OptionsMapperType => {
      const value = String(current[valueKey]);
      optionsMapper[value] =
        current[labelKey] != null ? String(current[labelKey]) : value;
      return optionsMapper;
    },
    {},
  );
}
